import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import { FuelControlHelpContent } from "./fuelControlHelpContent";
import FieldAppFuelControlMatrix from "./FieldAppFuelControlMatrix";

import "./FieldAppCalibrationPanel.css";

export default function FieldAppFuelControlPanel({
  t,
  summary,
  machineSummaries,
  recordCount = 0,
  children,
}) {
  return (
    <div className="field-app-calibration field-app-fuel-control">
      <div className="field-app-calibration-help" role="note">
        <FaInfoCircle className="field-app-calibration-help-icon" aria-hidden />
        <div className="field-app-calibration-help-body">
          <strong>{t("Para que serve esta ferramenta?")}</strong>
          <FuelControlHelpContent />
        </div>
      </div>

      <FieldAppFuelControlMatrix
        summary={summary}
        machineSummaries={machineSummaries}
        recordCount={recordCount}
        t={t}
      />

      {children}
    </div>
  );
}
